<template><section><h2>Nested Pie Chart 嵌套饼图</h2>
<block-demo tip="" source="const data = [
  { value: 204, name: &#39;图例一&#39; },
  { value: 451, name: &#39;图例二&#39; },
  { value: 347, name: &#39;图例三&#39; },
  { value: 256, name: &#39;图例四&#39; },

  { value: 2790, name: &#39;图例1&#39; },
  { value: 2548, name: &#39;图例2&#39; },
  { value: 1350, name: &#39;图例3&#39; },
  { value: 3100, name: &#39;图例4&#39; },
  { value: 2340, name: &#39;图例5&#39; },
  { value: 1350, name: &#39;图例6&#39; },
  { value: 2450, name: &#39;图例7&#39; },
  { value: 1550, name: &#39;图例8&#39; },
  { value: 3450, name: &#39;图例9&#39; },
  { value: 2750, name: &#39;图例10&#39; }
]

const { Chart, Pie, Legend, Tooltip, theme } = qcharts
const colors1 = [&#39;#5982F6&#39;, &#39;#59CB74&#39;, &#39;#DA65CC&#39;, &#39;#FC6980&#39;]
const colors2 = [&#39;#47A1FF&#39;, &#39;#6CD3FF&#39;, &#39;#A2E5FF&#39;, &#39;#4DCCCB&#39;, &#39;#3FDDC7&#39;, &#39;#ADDF84&#39;, &#39;#FBD54A&#39;, &#39;#FFB952&#39;, &#39;#F79452&#39;, &#39;#E37474&#39;]
const colors = colors1.concat(colors2)
theme.set({ colors })
const chart = new Chart({
  container: &#39;#app&#39;
})

chart.source(data, {
  row: &#39;name&#39;,
  value: &#39;value&#39;
})

const ds = chart.dataset

const pie = new Pie({
  radius: 0.4,
  pos: [0, 0]
}).source(ds.selectRows(data.slice(0, 4).map(d =&gt; d.name)))

//可以通过设置单个visual的主题，设置样式和属性
pie.theme.set({
  colors: colors1,
  attrs: {},
  styles: {
    guideText: { borderRadius: 2, bgcolor: &#39;rgba(255,255,255,0.7)&#39; }
  }
})

const pie2 = new Pie({
  innerRadius: 0.5,
  radius: 0.7
}).source(ds.selectRows(data.slice(4).map(d =&gt; d.name)))

pie2.theme.set({ colors: colors2 })
const legend = new Legend({ orient: &#39;vertical&#39;, align: [&#39;right&#39;, &#39;center&#39;] })

chart.append([pie2, pie, legend])
"><pre v-pre><code v-pre class="language-javascript"><span class="hljs-keyword">const</span> data = [
  { <span class="hljs-attr">value</span>: <span class="hljs-number">204</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例一'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">451</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例二'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">347</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例三'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">256</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例四'</span> },

  { <span class="hljs-attr">value</span>: <span class="hljs-number">2790</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例1'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2548</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例2'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1350</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例3'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3100</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例4'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2340</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例5'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1350</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例6'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2450</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例7'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">1550</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例8'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">3450</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例9'</span> },
  { <span class="hljs-attr">value</span>: <span class="hljs-number">2750</span>, <span class="hljs-attr">name</span>: <span class="hljs-string">'图例10'</span> }
]

<span class="hljs-keyword">const</span> { Chart, Pie, Legend, Tooltip, theme } = qcharts
<span class="hljs-keyword">const</span> colors1 = [<span class="hljs-string">'#5982F6'</span>, <span class="hljs-string">'#59CB74'</span>, <span class="hljs-string">'#DA65CC'</span>, <span class="hljs-string">'#FC6980'</span>]
<span class="hljs-keyword">const</span> colors2 = [<span class="hljs-string">'#47A1FF'</span>, <span class="hljs-string">'#6CD3FF'</span>, <span class="hljs-string">'#A2E5FF'</span>, <span class="hljs-string">'#4DCCCB'</span>, <span class="hljs-string">'#3FDDC7'</span>, <span class="hljs-string">'#ADDF84'</span>, <span class="hljs-string">'#FBD54A'</span>, <span class="hljs-string">'#FFB952'</span>, <span class="hljs-string">'#F79452'</span>, <span class="hljs-string">'#E37474'</span>]
<span class="hljs-keyword">const</span> colors = colors1.concat(colors2)
theme.set({ colors })
<span class="hljs-keyword">const</span> chart = <span class="hljs-keyword">new</span> Chart({
  <span class="hljs-attr">container</span>: <span class="hljs-string">'#app'</span>
})

chart.source(data, {
  <span class="hljs-attr">row</span>: <span class="hljs-string">'name'</span>,
  <span class="hljs-attr">value</span>: <span class="hljs-string">'value'</span>
})

<span class="hljs-keyword">const</span> ds = chart.dataset

<span class="hljs-keyword">const</span> pie = <span class="hljs-keyword">new</span> Pie({
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.4</span>,
  <span class="hljs-attr">pos</span>: [<span class="hljs-number">0</span>, <span class="hljs-number">0</span>]
}).source(ds.selectRows(data.slice(<span class="hljs-number">0</span>, <span class="hljs-number">4</span>).map(<span class="hljs-function"><span class="hljs-params">d</span> =&gt;</span> d.name)))

<span class="hljs-comment">//可以通过设置单个visual的主题，设置样式和属性</span>
pie.theme.set({
  <span class="hljs-attr">colors</span>: colors1,
  <span class="hljs-attr">attrs</span>: {},
  <span class="hljs-attr">styles</span>: {
    <span class="hljs-attr">guideText</span>: { <span class="hljs-attr">borderRadius</span>: <span class="hljs-number">2</span>, <span class="hljs-attr">bgcolor</span>: <span class="hljs-string">'rgba(255,255,255,0.7)'</span> }
  }
})

<span class="hljs-keyword">const</span> pie2 = <span class="hljs-keyword">new</span> Pie({
  <span class="hljs-attr">innerRadius</span>: <span class="hljs-number">0.5</span>,
  <span class="hljs-attr">radius</span>: <span class="hljs-number">0.7</span>
}).source(ds.selectRows(data.slice(<span class="hljs-number">4</span>).map(<span class="hljs-function"><span class="hljs-params">d</span> =&gt;</span> d.name)))

pie2.theme.set({ <span class="hljs-attr">colors</span>: colors2 })
<span class="hljs-keyword">const</span> legend = <span class="hljs-keyword">new</span> Legend({ <span class="hljs-attr">orient</span>: <span class="hljs-string">'vertical'</span>, <span class="hljs-attr">align</span>: [<span class="hljs-string">'right'</span>, <span class="hljs-string">'center'</span>] })

chart.append([pie2, pie, legend])
</code></pre>
</block-demo></section></template><script>export default {components:{}}</script>